import network from '../../utils/network';
import config from '../../config';
import { ACTION_BEGIN, ACTION_FAILURE } from '../app';

export const FETCH_TRANSITIONS_DAT_SUCCESS = 'FETCH_TRANSITIONS_DAT_SUCCESS';
export const FETCH_TRANSITIONS_JSON_SUCCESS = 'FETCH_TRANSITIONS_JSON_SUCCESS';

export const fetchTransitionsDat = () =>
  network.actionWrapper(
      `${config.getApiUrl()}/transitions.dat`,
      {
          begin: ACTION_BEGIN,
          success: FETCH_TRANSITIONS_DAT_SUCCESS,
          failure: ACTION_FAILURE,
      });

export const fetchTransitionsJson = () =>
    network.actionWrapper(
        `${config.getApiUrl()}/transitions.json`,
        {
          begin: ACTION_BEGIN,
          success: FETCH_TRANSITIONS_JSON_SUCCESS,
          failure: ACTION_FAILURE,
        });
